<template>
  <div class="analyse-container">
    <div class="page-content" style="width:300px">
      <el-input placeholder="输入关键字进行过滤" size="mini" v-model="filterText" clearable></el-input>
      <el-tree ref="tree" style="margin-top:10px" class="filter-tree" :filter-node-method="filterNode" :data="treeData"
        node-key="id" default-expand-all :expand-on-click-node="false"></el-tree>
    </div>
    <div class="page-content" style="flex:1;margin-left:0;">
      <div class="page-content border-bottom" style="margin-top:0;">
        <!-- 顶部搜索框 -->
        <div>
          <el-form :inline="true" :model="queryParams" class="demo-form-inline">
            <el-form-item label="部门名称">
              <el-input v-model="queryParams.deptName" placeholder="请输入部门名称进行查询" class="form-item-width"
                clearable></el-input>
            </el-form-item>
            <el-form-item class="right-btns">
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button type="warning" @click="onReset">重置</el-button>
              <!-- <el-button type="primary" @click="handledeptAdd">新增车间</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="page-content margin-top" style="margin-bottom:0">
        <!-- 表格组件 -->
        <el-table :data="tableData" stripe border style="width: 100%"
          :header-cell-style="{ background: '#aef1f6', color: '#606266' }">
          <!-- 序号列 -->
          <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>

          <!-- 动态生成其他列 -->
          <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
            show-overflow-tooltip :width="tab.width">
            <template slot-scope="scope">
              <!-- 针对 status 列的特殊处理 -->
              <span v-if="tab.code === 'status'"
                :style="scope.row.status === '0' ? { color: 'green', cursor: 'pointer' } : { color: 'red', cursor: 'pointer' }">{{
        scope.row.status === '0' ? '正常' : '停用' }}</span>
              <!-- 其他列的常规展示 -->
              <span v-else>{{ scope.row[tab.code] || '暂无' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
              <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div>
          <Pagination :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
            @pagination="onChangePages" />
        </div>
      </div>
      <!-- 添加 修改部门 -->
      <el-dialog :title="dialogTitle" :visible.sync="deptFormVisible" width="30%" @close="handleDialogClose">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item label="部门名称" prop="deptName">
            <el-input v-model="form.deptName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="leader">
            <el-input v-model="form.leader" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序" prop="orderNum">
            <el-input v-model="form.orderNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="部门状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择部门状态">
              <el-option label="正常" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('form')">{{ dialogTitle === '新增车间' ? '立即添加' : '立即修改'
            }}</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {  getDeptTree,deptAdd,deptById,updeteDept,deleteDept} from "@/api/admin-service/dept";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      form: {
        parentId: "", //新增车间 需要上级id 默认是第一级
        deptName: "", //部门名称
        leader: "", //负责人
        orderNum: "", //显示顺序
        phone: "", //联系电话
        status: "", //部门状态
        // delFlag: "0" // ?
      },
      rules: {
        deptName: [
          { required: true, message: "请填写部门名称", trigger: "blur" }
        ],
        leader: [{ required: true, message: "请填写负责人", trigger: "blur" }],
        orderNum: [
          {
            required: true,
            message: "请填写显示顺序",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/, // 正则表达式，匹配大于等于 0 的正整数
            message: "请输入大于等于 0 的正整数",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请填写联系电话",
            trigger: "blur"
          },
          {
            pattern: /^1[3-9]\d{9}$/, // 正则表达式，匹配中国大陆手机号
            message: "请输入合法的手机号",
            trigger: "blur"
          }
        ],
        status: [
          { required: true, message: "请选择部门状态", trigger: "change" }
        ]
      },
      treeData: [],
      filterText: "", // 过滤树的值
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "部门名称", code: "deptName", width: "" },
        { name: "负责人", code: "leader", width: "" },
        { name: "显示顺序", code: "orderNum", width: "" },
        { name: "电话", code: "phone", width: "" },
        { name: "部门状态", code: "status", width: "" }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        parentId: 0,
        deptName: "",
        orderBy: ""
      }
    };
  },
  mounted() {
    this.onGetDataList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增车间") {
            deptAdd(this.form).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDept({
              ...this.form,
              deptId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm("提示,确定要删除这条数据吗", {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteDept({ ids: [row.deptId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改车间信息";
      this.deptFormVisible = true;
      this.updateId = row.deptId;
      deptById({ id: row.deptId }).then(res => {
        this.form = res.data;
      });
    },
    // 查
    onGetDataList() {
      getDeptTree({}).then(res => {
        this.treeData = res.data;
      });
    },

    handledeptAdd() {
      this.dialogTitle = "新增车间";
      this.deptFormVisible = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.deptName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
